// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__iMX2Q","abort":"style_abort__1sDyU","submit":"style_submit__2JNAh"};